export default __webpack_public_path__ + "assets/9ebb652b55d99d0759760f4b7205a90e.svg";